/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `ChatFileUploadArea` for the Caintra Connect frontend.
 * @module components/Chat/ChatFileUploadArea
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import FileUploadArea from "../../modals/ProposalCreateModal/FileUploadArea.jsx";

const ChatFileUploadArea = ({
  styles,
  isMobile,
  selectedFile,
  isFileUploading,
  isDragging,
  fileError,
  onFileChange,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileClick,
}) => (
  <div className={styles.fileUploadContainer}>
    <FileUploadArea
      file={selectedFile}
      isUploading={isFileUploading}
      isDragging={isDragging}
      error={fileError}
      onFileChange={onFileChange}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      onClick={onFileClick}
      reduceHeightForMobile={isMobile}
    />
    <input
      id="chat-file-input"
      type="file"
      onChange={onFileChange}
      className={styles.fileInput}
      style={{ display: "none" }}
      accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    />
  </div>
);

export default ChatFileUploadArea;
